// extracted by mini-css-extract-plugin
module.exports = {"title":"_1kvmC","footer":"_2d8rl"};